import { render, staticRenderFns } from "./ShipmentsReportV2.vue?vue&type=template&id=0e110ae5&scoped=true"
import script from "./ShipmentsReportV2.vue?vue&type=script&lang=js"
export * from "./ShipmentsReportV2.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsReportV2.vue?vue&type=style&index=0&id=0e110ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e110ae5",
  null
  
)

export default component.exports